const envSettings = window as typeof window & { [k: string]: string };
export default {
  ui: {
    deployEnv: envSettings.DEPLOY_ENV,
    siteName: envSettings.DEPLOY_STORAGE_CURRENT_SITE_NAME,
    authUrl: envSettings.DEPOLY_SSO_AUTH_URL,
    cookieDomain: envSettings.DEPLOY_PARENT_DOMAIN,
    isDefaultUI: false,
    contextMenuEnabled: true,
    clpLogoutUrl: `https://${envSettings.DEPLOY_AUTH_ADDR}/module.php/core/authenticate.php?as=tmss365-sp-${envSettings.DEPLOY_AUTH_ENV}&logout`,
    siteInfo: {
      v1: {
        prod_wu: 'https://portal.xdr.trendmicro.com',
        prod_we: 'https://portal.eu.xdr.trendmicro.com',
        prod_je: 'https://portal.jp.xdr.trendmicro.com',
        prod_ac: 'https://portal.au.xdr.trendmicro.com',
        prod_sa: 'https://portal.sg.xdr.trendmicro.com',
        prod_ci: 'https://portal.in.xdr.trendmicro.com',
        prod_nuae: 'https://portal.mea.xdr.trendmicro.com',
        stg_wu: 'https://portal-xdr.visionone.trendmicro.com',
        beta_wu: 'https://portal-int.visionone.trendmicro.com',
        dev_wu: 'https://portal-xdr.visionone.trendmicro.com',
        prod_uae_stg: 'https://portal-stg-uae.visionone.trendmicro.com',
      },
    },
    deployRegion: envSettings.DEPLOY_REGION,
    loginPage: {
      startFreeTrail: envSettings.CLP_REGISTRATION_TRIAL,
      contactReseller:
        'https://partner.trendmicro.com/en-US/partner-locator-home/',
      forgotPassword: envSettings.CLP_FORGOT_PASSWORD + '/Forgetpassword?T=TM',
    },
    request: {
      baseUrl: '',
      timeout: 60 * 1000,
    },
    upgradeDeadline: {
      globalPhase1: envSettings.UPGRADE_DEADLINE_GLOBAL_PHASE1 || '2026-02-28',
    },
    noAuthLogOff: true,
    timeZone: {
      defaultOffsetId: '32',
      defaultOffset: '+00:00',
    },
    // if this switch is decided by config and DB tm_global_setting for company,so it is for company'
    //!!important: if you want to add new feature toggle, please also add it to featureToggleForCompanyConfig
    featureToggle: {
      urlSandboxFeatureShow: envSettings.FEATURE_URL_SANDBOX_SWITCH === 'true',
      ddaTempQuarantineFeatureShow:
        envSettings.DEPLOY_FEATURE_VA_TEMP_QUARANTINE_ENABLE === 'true',
      smexQuarantineManagementEnabled:
        envSettings.DEPLOY_FEATURE_SMEX_HYBRID_QUARANTINE_MGMT_ENABLE ===
        'true',
      whiteLabelingFeatureToggle:
        envSettings.DEPLOY_WHITE_LABELING_ENABLED === 'true',
      writingStyleFeatureShow: envSettings.WRITING_STYLE_ENABLE === 'true',
      exOutboundTocFeatureShow: false,
      exchangeInlineFeatureShow: envSettings.EXCHANGE_INLINE_ENABLED === 'true',
      gmailInlineFeatureShow: envSettings.GMAIL_INLINE_ENABLED === 'true',
      notificationMailboxesFeatureShow:
        envSettings.NOTIFICATION_MAILBOXES_ENABLED === 'true',
      smexHybridFeatureShow:
        envSettings.DEPLOY_FEATURE_SMEX_HYBRID_ENABLE === 'true',
      logRestoreAllFeatureShow: false,
      googleDriveRealtimeScanSupport: false,
      newTeamsMultiAppsProvision:
        envSettings.NEW_TEAMS_MULTI_APPS_PROVISION === 'true',
      newSharepointMultiAppsProvision:
        envSettings.NEW_SHAREPOINT_MULTI_APPS_PROVISION === 'true',
      newOnedriveMultiAppsProvision:
        envSettings.NEW_ONEDRIVE_MULTI_APPS_PROVISION === 'true',
      gmailAddInConfigEnabled:
        envSettings.DEPLOY_GMAIL_ADDIN_CONFIG_ENABLED === 'true',
      passwordQuarantineFeatureShow:
        envSettings.DEPLOY_FEATURE_PASSWORD_QUARANTINE_ENABLE === 'true',
    },
    feature: {
      whiteLabeling: {
        enabled: envSettings.DEPLOY_WHITE_LABELING_ENABLED === 'true',
        path: envSettings.DEPLOY_WHITE_LABEL_PATH,
        fullName: 'Cyber Eye Cloud Service Security',
        firstName: 'Cyber Eye',
        lastName: 'Cloud Service Security',
      },
      urlSandboxFeatureShow: envSettings.FEATURE_URL_SANDBOX_SWITCH === 'true',
      phishInsight: envSettings.PHISH_INSIGHT_LINK,
    },
    //!!important this switch is a temp switch,when develop done,all will be open
    hideFeature: {
      redirectV1Banner: false,
      sideBar: {
        dashboard: false,
        log: envSettings.DEPLOY_SIDEBAR_LOG_SHOW === 'false',
        policy: envSettings.DEPLOY_SIDEBAR_POLICY_SHOW === 'false',
        report: false,
        quarantine: envSettings.DEPLOY_SIDEBAR_QUARANTINE_SHOW === 'false',
        administrator:
          envSettings.DEPLOY_SIDEBAR_ADMINISTRATOR_SHOW === 'false',
        visionOne: envSettings.DEPLOY_SIDEBAR_VISION_ONE_SHOW === 'false',
      },
      dashboard: {
        widgetCategory: false,
        exportPDFReport: false,
        exportVirtualAnalyzerABlockList: false,
      },
      header: {
        accountSwitch: false,
        accountSetting: {
          logOff: false,
        },
        colorSwitch: false,
      },
    },
    policy: {
      policyTemplateType: {
        emailTypes: [1, 82, 21, 22],
        collaborationTypes: [2, 3, 4, 5, 6, 9, 10, 41, 42],
      },
      //!!important this switch is a temp switch,when develop done,all will be open
      featureShow: {
        emailAdvancedThreatProtection: true,
        emailDataLossPrevention: true,
        collaborationAdvancedThreatProtection: true,
        collaborationDataLossPrevention: true,
      },
    },
    administrator: {
      featureShow: {
        organization: true,
        serviceAccount: true,
        userRole: true,
        license: true,
        SingleSignOn: true,
        apiToken: true,
        euq: envSettings.EUQ_ENABLE,
      },
      addInInstallLink: envSettings.ADD_IN_INSTALL_LINK,
      smartAlertAddInInstallLink: `https://${envSettings.DEPLOY_SA_ADDIN_FQDN}/manifest.xml`,
      apiTokenUrl: envSettings.API_TOKEN_URL,
    },
    globalSettings: {
      limitation: {
        approvedHeaderMaxLength: 128,
        approvedHeaderMaxNumber: 50,
        approvedUserMaxLength: 1024,
        blockedListMaxCount: 2048,
        predictiveMachineLearningMaxCount: 500,
        displayNameSpoofingDetectionExceptionListMaxCount: 500,
        recipientGroupInputMaxLength: 254,
        recipientGroupTextAreaMaxLength: 1024,
        recipientGroupMaxNumber: 21,
        highProfileUserExceptionListMaxCount: 500,
        highProfileUserMaxCount: 1000,
        orgNameMaxLength: 32,
        orgTextAreaMaxLength: 1024,
        exchangePocUserLimit: 100,
      },
      //!!important this switch is a temp switch,when develop done,all will be open
      featureShow: {
        attachmentPasswordGuessing: true,
        conditionalAccessPoliciesForRiskyUsers: true,
        misdirectedEmailDetection:
          envSettings.DEPLOY_FEATURE_MISDIRECTED_EMAIL_DETECTION_ENABLE ===
          'true',
        microsoftLicensingModelSettingsForTeamsChat: true,
        inlineProtectionSettingsForExchangeOnline: true,
        inlineProtectionSettingsForGmail: true,
        highProfileList: true,
        internalDomainList: true,
        timeOfClickProtection: true,
        machineLearning: true,
      },
    },
  },
};
